import { render, staticRenderFns } from "./PcBVip.vue?vue&type=template&id=48cf2b8a&scoped=true&"
import script from "./PcBVip.vue?vue&type=script&lang=js&"
export * from "./PcBVip.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PcBVip.vue?vue&type=style&index=0&id=48cf2b8a&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "48cf2b8a",
  null
  ,true
)

export default component.exports